module.exports = __webpack_public_path__ + "media/images/lb/888-bf91b54c1e496581ae29378936400a01.svg";